// const Host = "http://127.0.0.1:8000/api";
// export const Site = "http://localhost:3001/";
//
export const Site = "https://booksmm.com/";
const Host = "https://site.booksmm.com/api";
export const api_Routes = {
  Auth: {
    login: `${Host}/admin/login`,
  },
  Groups: {
    PanelView: `${Host}/group/panels`,
    PanelViewByReseller: `${Host}/group/panelsByReseller`,
    TelegramView: `${Host}/TelegramGroups`,
    TelegramGetOne: `${Host}/getTelegramGroupsByid/`,
    TelegramAdd: `${Host}/AddTelegramGroups`,
    TelegramEdit: `${Host}/updateTelegramGroups/`,
    TelegramDelete: `${Host}/deleteTelegramGroups/`,
    Telegram: {
      View: `${Host}/TelegramGroups`,
      GetOne: `${Host}/getTelegramGroupsByid/`,
      Add: `${Host}/AddTelegramGroups`,
      Edit: `${Host}/updateTelegramGroups/`,
      Delete: `${Host}/deleteTelegramGroups/`,
      Reorder: `${Host}/reorderTelegramGroups/`,
    },
    Whatsapp: {
      View: `${Host}/WhatsappGroups`,
      GetOne: `${Host}/getWhatsappGroupsByid/`,
      Add: `${Host}/AddWhatsappGroups`,
      Edit: `${Host}/updateWhatsappGroups/`,
      Delete: `${Host}/deleteWhatsappGroups/`,
      Reorder: `${Host}/reorderWhatsappGroups/`,
    },
    Skype: {
      View: `${Host}/getAllGroupSkype`,
      GetOne: `${Host}/getGroupSkypeById/`,
      Add: `${Host}/addSkypeGroups`,
      Edit: `${Host}/updateSkypeGroups/`,
      Delete: `${Host}/deleteSkypeGroups/`,
      Reorder: `${Host}/reorderSkypeGroups/`,
    },
  },
  ShopAds: {
    View: `${Host}/admin/ourService`,
    Add: `${Host}/admin/ourService`,
    Edit: `${Host}/admin/ourService`,
    GetOne: `${Host}/admin/ourService`,
    Delete: `${Host}/admin`,
  },
  Type: {
    Add: `${Host}/admin/type`,
    Edit: `${Host}/admin/type`,
    Delete: `${Host}/admin`,
  },
  PinsAdvertising: {
    View: `${Host}/admin/pins`,
    UpdateStatus: `${Host}/admin/pins/changeStatus/`,
    Edit: `${Host}/admin/pin/editPin/`,
    GetOne: `${Host}/admin/pin/`,
  },
  BannersAdvertising: {
    View: `${Host}/admin/banner`,
    UpdateStatus: `${Host}/admin/banner/changeStatus/`,
    Edit: `${Host}/admin/banner/editBanner/`,
    GetOne: `${Host}/admin/banner/`,
  },
  TopResultAdvertising: {
    View: `${Host}/admin/TopResult`,
    UpdateStatus: `${Host}/admin/TopResult/changeStatus/`,
    GetOne: `${Host}/admin/TopResult/`,
  },
  TicketsAdvertising: {
    View: `${Host}/admin/ticketAds`,
    UpdateStatus: `${Host}/admin/ticketAds/changeStatus/`,
    UpdateCountTicket: `${Host}/admin/ticketAds/change_count_ticket_send/`,
    Edit: `${Host}/admin/EditTicketAds/`,
    GetOne: `${Host}/admin/ticketAds/`,
  },
  Trust: {
    Edit: `${Host}/admin/trusts/`,
  },
  AddBalanceRequests: {
    View: `${Host}/admin/AddBalanceRequest`,
    Add: `${Host}/admin/AddBalanceRequest`,
    Edit: `${Host}/admin/AddBalanceRequest/`,
    GetOne: `${Host}/admin/getAddBalanceRequestById/`,
  },
  OrderRequests: {
    View: `${Host}/admin/OrderRequest`,
    Add: `${Host}/admin/OrderRequest`,
    Edit: `${Host}/admin/OrderRequest/`,
    GetOne: `${Host}/admin/getOrderRequestById/`,
  },
  Orders: {
    View: `${Host}/admin/Order`,
    ViewByOffers: `${Host}/admin/OrderOffer`,
    ViewAll: `${Host}/admin/OrderAll`,
    ViewAllRequest: `${Host}/admin/RequestAll`,
    Export: `${Host}/admin/Order/export`, // Add this
    ExportAll: `${Host}/admin/AllOrder/export`, // Add this
    ExportByOffers: `${Host}/admin/OrderOffer/export-by-offers`, // Add this
    Add: `${Host}/admin/Order`,
    GetOne: `${Host}/admin/getOrderById/`,
    AddOfferOrder: `${Host}/admin/CreateOfferOrder`,
    Edit: `${Host}/admin/Order/`,
    AddCustomOffer: `${Host}/admin/CreateCustomOffer`,
    ViewUpdated: `${Host}/admin/updated-requests`,
    ProcessUpdated: `${Host}/admin/updated-requests`,
  },
  Transactions: {
    View: `${Host}/admin/Transaction`,
  },
  Deposits: {
    View: `${Host}/admin/Deposit`,
    Export: `${Host}/admin/Deposit/export`,
    Edit: `${Host}/admin/Deposit/`,
  },
  Countries: {
    View: `${Host}/countries`,
  },
  Users: {
    View: `${Host}/admin/users`,
    CampaignsView: `${Host}/admin/Campaigns`,
    UserCampaignsView: `${Host}/admin/userCampaigns`,
    Groups: `${Host}/admin/userGroups`,
    ViewAll: `${Host}/admin/AllUsers`,
    ViewAllByReseller: `${Host}/admin/AllUsersByReseller`,
    Edit: `${Host}/admin/ediUser/`,
    AddBalance: `${Host}/admin/addBalance/`,
    BulkActions: `${Host}/admin/BulkActions`,
    SendBulkEmail: `${Host}/admin/SendBulkEmail`,
    SendBulkEmailTemplate: `${Host}/admin/SendBulkEmailTemplate`,
    SendBulkTicket: `${Host}/admin/SendBulkTicket`,
    Add: `${Host}/admin/addUser`,
    ViewUserDetails: `${Host}/admin/user/`,
    ViewCampaignDetails: `${Host}/admin/campaign/`,
    ViewUserCampaignDetails: `${Host}/admin/userCampaign/`,
    ViewEmailDetails: `${Host}/admin/email/`,
    ViewUserEmailDetails: `${Host}/admin/userEmail/`,
    EmailTemplates: `${Host}/admin/email-templates`,
  },
  Membership: {
    View: `${Host}/admin/memberships`,
    ViewAll: `${Host}/admin/AllMemberships`,
    Edit: `${Host}/admin/editMembership/`,
    Add: `${Host}/admin/addMembership`,
    ViewUserDetails: `${Host}/admin/membership/`,
  },
  MembershipService: {
    View: `${Host}/admin/membershipServices`,
    ViewAll: `${Host}/admin/AllMembershipServices`,
    Edit: `${Host}/admin/editMembershipService/`,
    Add: `${Host}/admin/addMembershipService`,
    ViewDetails: `${Host}/admin/membershipService/`,
  },
  MembershipGroup: {
    View: `${Host}/admin/membershipGroups`,
    ViewAll: `${Host}/admin/AllMembershipGroups`,
    Edit: `${Host}/admin/editMembershipGroup/`,
    Add: `${Host}/admin/addMembershipGroup`,
    ViewDetails: `${Host}/admin/membershipGroup/`,
  },
  MembershipSubscription: {
    View: `${Host}/admin/membershipSubscriptions`,
    ViewAll: `${Host}/admin/AllMembershipSubscriptions`,
    Edit: `${Host}/admin/editMembershipSubscription/`,
    Add: `${Host}/admin/addMembershipSubscription`,
    ViewDetails: `${Host}/admin/membershipSubscription/`,
  },
  Employees: {
    View: `${Host}/admin/employees`,
    GetManagers: `${Host}/admin/employees/managers`,
    GetOne: `${Host}/admin/employee/`,
    Edit: `${Host}/admin/employee/`,
    Add: `${Host}/admin/employee`,
    Delete: `${Host}/admin/employee/`,
  },
  Profile: {
    Get: `${Host}/admin/profile`,
    Edit: `${Host}/admin/profile`,
  },
  Roles: {
    View: `${Host}/admin/roles`,
    GetAll: `${Host}/admin/allRoles`,
    GetOne: `${Host}/admin/roles/`,
    Edit: `${Host}/admin/roles/`,
    Add: `${Host}/admin/roles`,
    Delete: `${Host}/admin/roles/`,
  },
  Permissions: {
    View: `${Host}/admin/permissions`,
  },
  Panels: {
    View: `${Host}/admin/panels`,
    ViewAll: `${Host}/admin/allPanels`,
    GetOne: `${Host}/admin/panel/`,
    Edit: `${Host}/admin/panel/`,
    Add: `${Host}/admin/panel`,
    Delete: `${Host}/admin/panel/`,
    GetServices: `${Host}/admin/GetServices/`,
    screenshots: `${Host}/admin/take-screenshot/`,
    log: `${Host}/admin/panel/log`,
    importPanel: `${Host}/admin/import-panels`,
  },
  Categories: {
    View: `${Host}/admin/categories`,
    ViewAll: `${Host}/admin/categories/all`,
    GetOne: `${Host}/admin/categories/`,
    Edit: `${Host}/admin/categories/`,
    Add: `${Host}/admin/categories`,
    Delete: `${Host}/admin/categories/`,
  },
  EmailProviders: {
    View: `${Host}/admin/emailProviders`,
    GetOne: `${Host}/admin/emailProviders/`,
    Edit: `${Host}/admin/emailProviders/`,
    Add: `${Host}/admin/emailProviders`,
    Delete: `${Host}/admin/emailProviders/`,
  },
  EmailTemplates: {
    View: `${Host}/admin/emailTemplates`,
    GetOne: `${Host}/admin/emailTemplates/`,
    Edit: `${Host}/admin/emailTemplates/`,
    Add: `${Host}/admin/emailTemplates`,
    AddWithSections: `${Host}/admin/emailTemplates/withSections`,
    EditWithSections: `${Host}/admin/emailTemplates/withSections/`,
    Delete: `${Host}/admin/emailTemplates/`,
  },
  SubCategories: {
    View: `${Host}/admin/subcategories`,
    GetOne: `${Host}/admin/subcategories/`,
    Edit: `${Host}/admin/subcategories/`,
    Add: `${Host}/admin/subcategories`,
    Delete: `${Host}/admin/subcategories/`,
  },
  Slider: {
    View: `${Host}/admin/sliders`,
    GetOne: `${Host}/admin/sliders/`,
    Edit: `${Host}/admin/sliders/`,
    Add: `${Host}/admin/sliders`,
    Delete: `${Host}/admin/sliders/`,
  },
  Support: {
    View: `${Host}/admin/TicketsSupport`,
    viewTicket: `${Host}/admin/MessageByTicket/`,
    Replay: `${Host}/admin/CreateMessage`,
    UpdateStatus: `${Host}/admin/UpdateChatStatus`,
  },
  Services: {
    View: `${Host}/admin/ourService`,
    ViewTicketsFilter: `${Host}/admin/ticketAds/filterServices`,
  },
  Offers: {
    View: `${Host}/admin/getAllOffers`,
    GetOne: `${Host}/admin/getOfferById/`,
    Edit: `${Host}/admin/updateOffers/`,
    Add: `${Host}/admin/createOffers`,
    Delete: `${Host}/admin/deleteOfferById/`,
  },
  dashboard: {
    getStatistics: `${Host}/admin/getDashboardStats`,
    getDetailedStatistics: `${Host}/admin/getDetailedDashboardStats`,
  },
  Review: {
    Panels: `${Host}/admin/panelsReviwes`,
    Services: `${Host}/admin/ServicesReviwes`,
    PanelDelete: `${Host}/admin/deleteReview/`,
    ServiceDelete: `${Host}/admin/deleteServiceReview/`,
    PanelVerify: `${Host}/admin/verifyReview/`,
    ServiceVerify: `${Host}/admin/verifyServiceReview/`,
  },
  Notifications: {
    View: `${Host}/admin/getNotifications`,
    ViewAll: `${Host}/admin/getAllNotifications`,
    Read: `${Host}/admin/readNoification`,
    ReadAll: `${Host}/admin/readAllNoifications`,
  },
  Faqs: {
    View: `${Host}/faqs`,
    GetOne: `${Host}/faqs`,
    Add: `${Host}/admin/faqs`,
    Edit: `${Host}/admin/updateFaqs/`,
    Delete: `${Host}/admin/faqs/`,
  },
  Marketers: {
    View: `${Host}/marketers`,
    GetOne: `${Host}/marketers`,
    Add: `${Host}/admin/marketers`,
    Edit: `${Host}/admin/updateMarketers/`,
    Delete: `${Host}/admin/marketers/`,
  },
  Settings: {
    View: `${Host}/admin/settings`,
    Edit: `${Host}/admin/settings`,
  },
  Smmticket: {
    View: `${Host}/admin/smmticket/profile`,
    Campaigns: `${Host}/admin/smmticket/campaigns`,
    Tickets: `${Host}/admin/smmticket/tickets`,
    SendTickets: `${Host}/admin/smmticket/resend/`,
  },
  PaymentMethods: {
    get: `${Host}/getpaymentmethods`,
  },
  UpdatedPanels: {
    View: `${Host}/admin/updated-panels`,
    Process: `${Host}/admin/updated-panels`,
  },
  Pages: {
    View: `${Host}/admin/pages`,
    Edit: `${Host}/admin/pages`,
  },
  UserAds: {
    View: `${Host}/admin/userads/ads`,
    BulkActions: `${Host}/admin/userads/bulk-actions`,
    GetOnt: `${Host}/admin/userads/ad`,
    UpdateStatus: `${Host}/admin/userads/ad`,

  },
  LastMinutes: {
    View: `${Host}/admin/lastMinutes`,
    GetOnt: `${Host}/admin/lastMinutes/lastMinute`,
    UpdateStatus: `${Host}/admin/lastMinutes/lastMinute`,
  },
  AdCategories: {
    View: `${Host}/admin/userads/adcategories`,
    GetOne: `${Host}/admin/userads/adcategories`,
    Add: `${Host}/admin/userads/adcategories`,
    Edit: `${Host}/admin/userads/adcategories`,
    Delete: `${Host}/admin/userads/adcategories`,
    GetAll: `${Host}/admin/userads/adcategories/all`,
  },
  AdSubCategories: {
    View: `${Host}/admin/userads/adsubcategories`,
    GetOne: `${Host}/admin/userads/adsubcategories`,
    Add: `${Host}/admin/userads/adsubcategories`,
    Edit: `${Host}/admin/userads/adsubcategories`,
    Delete: `${Host}/admin/userads/adsubcategories`,
    GetAll: `${Host}/admin/userads/adsubcategories/all`,
  },
  AdSubCategoryTypes: {
    View: `${Host}/admin/userads/adsubcategorytypes`,
    GetOne: `${Host}/admin/userads/adsubcategorytypes`,
    Add: `${Host}/admin/userads/adsubcategorytypes`,
    Edit: `${Host}/admin/userads/adsubcategorytypes`,
    Delete: `${Host}/admin/userads/adsubcategorytypes`,
  },
  SmmDomain: {
    GetAll: `${Host}/admin/smmDomain`,
    GetAllRequests: `${Host}/admin/smmDomain/request`,
    GetOne: `${Host}/admin/smmDomain`,
    Add: `${Host}/admin/smmDomain`,
    Edit: `${Host}/admin/smmDomain`,
    Delete: `${Host}/admin/smmDomain`,
    EditRequestStatus: `${Host}/admin/smmDomain/requestStatus`,
  },
  Resellers: {
    View: `${Host}/admin/resellers`,
    AvailablePanels: `${Host}/admin/resellers/available_panels`,
    SearchAvailable: `${Host}/admin/resellers/available-search`,
    GetOne: `${Host}/admin/resellers`,
    Store: `${Host}/admin/resellers`,
    Edit: `${Host}/admin/resellers`,
    Delete: `${Host}/admin/resellers/`,
    GetOneByAdmin: `${Host}/admin/resellers/byadmin`,
  },
  CK: {
    UploadImage: `${Host}/upload-image`,
  },
  UserChat: {
    View: `${Host}/admin/conversations`,
    Start: `${Host}/admin/conversations/start`,
    Group: `${Host}/admin/groups`,
    GroupMessages: `${Host}/admin/groups/messages`,
    GroupInfo: `${Host}/admin/groups/info`,
    CreateGroup: `${Host}/admin/groups`,
    StartChat: `${Host}/admin/chat`,
    SendMessage: `${Host}/admin/conversations/message`,
    SendGroupMessage: `${Host}/admin/groups/message`,
    SendDirectMessage: `${Host}/admin/conversations/direct_message`,
    Channel: `${Host}/admin/channels`,
    ChannelMessages: `${Host}/admin/channels/messages`,
    ChannelInfo: `${Host}/admin/channels/info`,
    CreateChannel: `${Host}/admin/channels`,
    SendChannelMessage: `${Host}/admin/channels/message`,
    GetChannelMemberRole: `${Host}/admin/channels/getrole`,
    JoinChannel : `${Host}/admin/channels/join`
  },
};
